import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/shards.min.css";
import "./assets/css/uicons-regular-rounded.css";
import "./assets/css/style.css";
import "./assets/scss/style.scss";

import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import { getToken, ssoLogin } from "./services/authService";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPasswordSubmit from "./pages/ForgotPasswordSubmit";
import { Provider } from "react-redux";
import store from "./store/Store";

toast.configure();


// ✅ ROUTE APP WITH SSO HANDLING
const RouteApp = () => {
  const token = getToken();

  // 🔥 FIX: Move SSO logic here
  useEffect(() => {
    const existingToken = localStorage.getItem("access_token");
    const hash = window.location.hash;

    if (!existingToken && hash && hash.includes("access_token")) {
      const params = new URLSearchParams(hash.substring(1));
      const msToken = params.get("access_token");

      if (msToken) {
        try {
          const payload = JSON.parse(atob(msToken.split(".")[1]));

          const email = payload.preferred_username || payload.upn;
          const name = payload.name;

          console.log("Microsoft User:", email, name);

          ssoLogin({ email, name })
            .then((res) => {
              localStorage.setItem("access_token", res.data.token);

              window.location.hash = "";
              window.location.href = "/dashboard/overview";
            })
            .catch((err) => {
              const message =
                err?.response?.data ||
                "User not registered. Contact admin.";

              toast.error(message);

              window.location.hash = "";
              window.location.href = "/";
            });

        } catch (e) {
          toast.error("Invalid Microsoft token");
          window.location.href = "/";
        }
      }
    }
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => {
            if (token) return <Redirect to="/dashboard/overview" />;
            return <Auth {...props} />;
          }}
        />

        <Route
          path="/dashboard"
          render={(props) => {
            if (!token) return <Redirect to="/" />;
            return <Dashboard {...props} />;
          }}
        />

        <Route
          path="/forgot-password"
          render={(props) => {
            if (token) return <Redirect to="/dashboard/overview" />;
            return <ForgotPassword {...props} />;
          }}
        />

        <Route
          path="/forgot-password-submit/:email"
          component={ForgotPasswordSubmit}
        />

        <Route path="/notfound" component={NotFound} />
        <Redirect from="*" to="/notfound" />
      </Switch>
    </BrowserRouter>
  );
};


// ✅ APP RENDER
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouteApp />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();